import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Breadcrumb } from '../models/breadcrumb';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private readonly breadcrumbsSource$ = new BehaviorSubject<Breadcrumb[]>([]);

  public setBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
    this.breadcrumbsSource$.next(breadcrumbs);
  }

  public breadcrumbs(): Observable<Breadcrumb[]> {
    return this.breadcrumbsSource$.asObservable();
  }
}
